import { Box, Flex, Center, Text } from "@chakra-ui/react";
import { DeleteSVG } from "assets";
import { CircularLoader } from "components";

interface Props {
  accountName: string;
  institutionName: string;
  fiatAccountId: string;
  handleDelete: (id: string) => void;
  deleteLoading: boolean;
  selectedFiatId: string;
}
const BankCard = ({ accountName, institutionName, handleDelete, fiatAccountId, deleteLoading, selectedFiatId }: Props) => {
  return (
    <Box padding="24px" width="100%" borderRadius="24px" bg="linear-gradient(to left, #9ace80, #0D4740)" color="#fff" mb="24px">
      <Flex justifyContent="space-between">
        <Box>
          <Text fontWeight="600" textTransform="capitalize">
            {accountName?.toLowerCase()}
          </Text>

          <Text textTransform="uppercase">{institutionName}</Text>
        </Box>

        <Center
          cursor="pointer"
          width="32px"
          height="32px"
          borderRadius="100%"
          bg="#fff"
          onClick={() => handleDelete(fiatAccountId)}
        >
          {deleteLoading && selectedFiatId === fiatAccountId ? <CircularLoader /> : <DeleteSVG width="16px" height="16px" />}
        </Center>
      </Flex>
    </Box>
  );
};

export default BankCard;
